import { render, staticRenderFns } from "./NaHradzi.vue?vue&type=template&id=6d86b887&scoped=true"
import script from "./NaHradzi.vue?vue&type=script&lang=js"
export * from "./NaHradzi.vue?vue&type=script&lang=js"
import style0 from "./NaHradzi.vue?vue&type=style&index=0&id=6d86b887&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86b887",
  null
  
)

export default component.exports